import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(firebaseApp);
export const database = getFirestore(firebaseApp);
export const storage = getStorage(firebaseApp);

// Connection status logging
if (database) {
    console.log(`✅ Connection to Firestore database established`);
} else {
    console.error(`❌ ERROR: No connection to Firestore database`);
}

if (storage) {
    console.log("✅ Connection to Firebase storage established");
} else {
    console.error("❌ ERROR: No connection to Firebase storage");
}

export default firebaseApp;